/**
 * Labstep
 *
 * @module components/Metadata/ShowEdit/Value/WithClear
 * @desc Rendering ShowEditValue + Clear action for metadata
 */

import { MetadataActionClearValue } from 'labstep-web/components/Metadata/Action/ClearValue';
import { MetadataActionCopy } from 'labstep-web/components/Metadata/Action/Copy';
import { MetadataFormShowEditValue } from 'labstep-web/components/Metadata/Form/ShowEdit/Value';
import { MetadataValue } from 'labstep-web/components/Metadata/Value';
import { Flex } from 'labstep-web/core/Flex';
import { Hoverable } from 'labstep-web/core/Hoverable';
import { Icon } from 'labstep-web/core/Icon';
import { TextPlaceholder } from 'labstep-web/core/Text/Placeholder';
import type React from 'react';
import styles from './styles.module.scss';
import type { MetadataFormShowEditValueWithClearProps } from './types';

export const MetadataFormShowEditValueWithClear: React.FC<
  MetadataFormShowEditValueWithClearProps
> = ({ metadata, entity, componentProps }) => {
  // If metadata is looked up, render read-only with source metadata
  if (metadata.field_definition?.lookup_relation_field_definition) {
    return metadata.lookup_source ? (
      <Hoverable
        className={styles.fieldName}
        hoverable={
          <MetadataValue
            metadata={metadata.lookup_source}
            canEdit={false}
          />
        }
        component={
          <Flex style={{ alignItems: 'baseline' }}>
            <Icon
              name="search"
              popup={{
                content: `Lookup from ${metadata.field_definition?.lookup_relation_field_definition.name}`,
              }}
            />
            <MetadataActionCopy
              metadata={metadata.lookup_source}
            />{' '}
          </Flex>
        }
      />
    ) : (
      <TextPlaceholder>Lookup Field</TextPlaceholder>
    );
  }

  // Normal editable metadata
  return (
    <Hoverable
      className={styles.fieldName}
      hoverable={
        <MetadataFormShowEditValue
          key={metadata.type}
          entity={entity}
          metadata={metadata}
          componentProps={componentProps}
        />
      }
      component={
        <Flex>
          <MetadataActionCopy metadata={metadata} />
          <MetadataActionClearValue
            metadata={metadata}
            entity={entity}
          />
        </Flex>
      }
    />
  );
};
